
import TopBar from "../components/TopBar";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Benefits from "../components/Benefits";
import FeaturedAssignments from "../components/FeaturedAssignments";
import Statistics from "../components/Statistics";
import HowItWorks from "../components/HowItWorks";
import AudienceSection from "../components/AudienceSection";
import AssignmentBoardPro from "../components/AssignmentBoardPro";
import Footer from "../components/layout/Footer";

function Home() {
  return (
    <div className="app">
      <TopBar />
      <Navbar />

      <main>
        <Hero />
        <AssignmentBoardPro />
        <Statistics />
        <HowItWorks />
        <AudienceSection />
        <Benefits />
        <FeaturedAssignments />
        
      </main>
      <Footer />
    </div>
  );
}

export default Home;